module.exports = __webpack_public_path__ + "img/yhgh5.98bd9993.png";